// Local storage service for offline functionality
import { generateId } from '../utils/helpers';

const STORAGE_KEY = 'typesync_snippets';
const SETTINGS_KEY = 'typesync_settings';

export const getLocalSnippets = (userId) => {
  try {
    const allSnippets = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    return allSnippets[userId] || [];
  } catch (error) {
    console.error('Error reading local snippets:', error);
    return [];
  }
};

export const saveLocalSnippets = (userId, snippets) => {
  try {
    const allSnippets = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    allSnippets[userId] = snippets;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(allSnippets));
    return true;
  } catch (error) {
    console.error('Error saving local snippets:', error);
    return false;
  }
};

export const addLocalSnippet = (userId, snippetData) => {
  try {
    const snippets = getLocalSnippets(userId);
    const newSnippet = {
      ...snippetData,
      id: generateId(),
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      usageCount: 0
    };
    
    snippets.push(newSnippet);
    saveLocalSnippets(userId, snippets);
    return newSnippet;
  } catch (error) {
    console.error('Error adding local snippet:', error);
    throw error;
  }
};

export const updateLocalSnippet = (userId, snippetId, updates) => {
  try {
    const snippets = getLocalSnippets(userId);
    const index = snippets.findIndex(s => s.id === snippetId);
    
    if (index !== -1) {
      snippets[index] = {
        ...snippets[index],
        ...updates,
        updatedAt: new Date().toISOString()
      };
      saveLocalSnippets(userId, snippets);
      return snippets[index];
    }
    
    throw new Error('Snippet not found');
  } catch (error) {
    console.error('Error updating local snippet:', error);
    throw error;
  }
};

export const deleteLocalSnippet = (userId, snippetId) => {
  try {
    const snippets = getLocalSnippets(userId);
    const filteredSnippets = snippets.filter(s => s.id !== snippetId);
    saveLocalSnippets(userId, filteredSnippets);
    return true;
  } catch (error) {
    console.error('Error deleting local snippet:', error);
    throw error;
  }
};

export const getLocalSettings = (userId) => {
  try {
    const allSettings = JSON.parse(localStorage.getItem(SETTINGS_KEY) || '{}');
    return allSettings[userId] || {
      defaultTypingSpeed: 80,
      randomVariation: 30,
      enableBackspaces: true,
      theme: 'light'
    };
  } catch (error) {
    console.error('Error reading local settings:', error);
    return {
      defaultTypingSpeed: 80,
      randomVariation: 30,
      enableBackspaces: true,
      theme: 'light'
    };
  }
};

export const saveLocalSettings = (userId, settings) => {
  try {
    const allSettings = JSON.parse(localStorage.getItem(SETTINGS_KEY) || '{}');
    allSettings[userId] = {
      ...settings,
      updatedAt: new Date().toISOString()
    };
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(allSettings));
    return true;
  } catch (error) {
    console.error('Error saving local settings:', error);
    return false;
  }
};
